import { Button, Modal } from '@mui/material';
import Loading from "components/Loading";
import React, { useEffect } from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import {Cancel} from '@mui/icons-material';

const Text = styled.span`
  color: ${COLOR.black500};
  font-size: 11px;
  margin-top: 2px;
  // text-align: left;
`;

const ModalRowDelete = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
`;
const ModalContentDelete = styled.div`
  align-items: center;
  background-color: ${COLOR.white};
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px;
  padding: 22px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const DeleteModal = ({ deleteToggle, setDeleteToggle, message, onDelete, loading, buttonTitle = 'Delete', colorSchema = "secondary", onClickCancel = () => {}, extraContent, disableConfirm = false, modalZIndex = null }) => {
  useEffect(() => {
    const classNames = ["overflow-hidden", "pr-8px", "md-pr-0px"];

    if (deleteToggle) {
      document.body.classList.add(...classNames);
    } else {
      document.body.classList.remove(...classNames);
    }
    return () => {
      document.body.classList.remove(...classNames);
    };
  }, [deleteToggle]);

  const handleCancel = () => {
    if(onClickCancel){
      onClickCancel();
    }
    setDeleteToggle(false);
  }
  
  return (
    <Modal disableScrollLock={true} open={Boolean(deleteToggle)} sx={modalZIndex ? { zIndex: modalZIndex } : undefined} onClose={() => {
      if (!loading) {
        setDeleteToggle(false)
      }
    }}>
      <ModalContentDelete>
        <Cancel className="studyDeleteIcon" />

        <div className="studyDletTxt">
          <h3>Are you sure?</h3>
        </div>

        <Text>
          <strong style={{ fontSize: 16, fontWeight: 500, color: "black" }}>
            {message}
          </strong>
        </Text>
        {extraContent}
        <ModalRowDelete>
          <Button
            className="studyCanDltBtn"
            style={{ marginRight: "4px" }}
            onClick={() => handleCancel()}
          >
            CANCEL
          </Button>
          <Button
            color={colorSchema}
            variant="contained"
            onClick={onDelete}
            disabled={loading || disableConfirm}
          >
            {loading ? <Loading white size={14} /> : null} {buttonTitle}
          </Button>
        </ModalRowDelete>
      </ModalContentDelete>
    </Modal>
  );
};
